import { X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Button } from 'src/components/ui/button';

interface InvoiceLineItemNoteModalProps {
  invoiceLineItem?: any;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  updateLineItem: (lineItemId: string, field: string, value: any) => void;
}

const InvoiceLineItemNoteModal: React.FC<InvoiceLineItemNoteModalProps> = ({
  invoiceLineItem,
  isOpen,
  onOpenChange,
  updateLineItem,
}) => {
  if (!isOpen) return null;

  useEffect(() => {
    if (invoiceLineItem) {
      setNotes(invoiceLineItem.notes || '');
    }
  }, [invoiceLineItem]);

  useEffect(() => {
    if (!isOpen && invoiceLineItem) {
      setNotes(invoiceLineItem.notes || '');
    }
  }, [isOpen, invoiceLineItem]);

  if (!isOpen || !invoiceLineItem) return null;

  const [notes, setNotes] = useState(invoiceLineItem.notes);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white p-3 px-4 pb-4 rounded-md shadow-xl min-w-[320px]">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-md font-bold">
            Line Item Note
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onOpenChange(false)}
            aria-label="Close"
            className="text-gray-500 hover:text-gray-800"
          >
            <X className='h-5 w-5' />
          </Button>
        </div>
        <div className="flex">
          <input
            type="text"
            className="w-full p-2 border border-gray-300 rounded-md"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            onBlur={(e) => updateLineItem(invoiceLineItem.id, 'notes', notes)}
          />
          <Button
            variant="primary"
            size="sm"
            onClick={() => updateLineItem(invoiceLineItem.id, 'notes', null)}
            aria-label="Save"
            className="text-white hover:text-white rounded-md ml-1 p-5 bg-blue-500"
          >
            <X className='h-5 w-5' />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceLineItemNoteModal;
